import { Grid, Icon } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";

function SinDatos({ textoTitulo }) {
  return (
    <Grid container textAlign={"center"} py={3}>
      <Grid item xs={12}>
        <Icon
          sx={{
            width: "50px",
          }}
        >
          folder_open
        </Icon>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography variant="h6">{textoTitulo || "No hay datos"}</SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography variant="caption" component="p" color="text">
          No hay datos para mostrar
        </SoftTypography>
      </Grid>
    </Grid>
  );
}
SinDatos.propTypes = {
  textoTitulo: PropTypes.string,
};

export default SinDatos;
